'use client'

import type React from 'react'
import { useId } from 'react'
import { Tooltip as ReactTooltip } from 'react-tooltip'

interface TooltipProps {
	content: React.ReactNode
	children: React.ReactNode
	place?: 'top' | 'bottom' | 'left' | 'right'
	delay?: number
}

const Tooltip: React.FC<TooltipProps> = ({ content, children, place = 'top', delay = 200 }) => {
	const id = useId()

	return (
		<>
			<span data-tooltip-id={id}>{children}</span>
			<ReactTooltip
				id={id}
				content={typeof content === 'string' ? content : undefined}
				place={place}
				delayShow={delay}
				className="!max-w-xs !whitespace-normal !break-words rounded-md! px-3! py-2! font-medium! text-xs!"
				noArrow={false}
			>
				{typeof content !== 'string' ? content : null}
			</ReactTooltip>
		</>
	)
}

export default Tooltip
